export default {
	common: {
		noMore: 'No more!',
		noData: 'No data!',
		loading: 'Loading...',
		gotIt: 'Got it',
		confirm: 'Confirm',
		cancel: 'Cancel',
	},
	activity: {
		title: 'Activity',
		rule: 'Promotion Rules',
		stockNotEnough: 'Stock not enough',
		soldOut: 'Sold out',
		addCartSuccess: 'Add cart success',
		maxPurchaseLimit: 'Maximum purchase limit: {num}',
	},
	inivteFriends: {
		title: 'Invite Friends',
		earn: 'Earn',
		for: 'for',
		eachFriendInvited: 'each friend invited',
		myRewards: 'My Rewards',
		received: 'Received',
		invited: 'Invited',
		shareNow: 'Share Now',
		welcomeGift: 'welcome gift',
		invitedFriends: 'Invited Friends',
		noSuccessfulInvites: 'No successful invites yet',
		howItWorks: 'How It Works',
	},
	document:{
		title: 'Document',
	}
}
